// removed by extract-text-webpack-plugin
module.exports = {"select":"_3yOGw","tabs":"_1fIlu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/TabSelect/TabSelect.scss
// module id = 1505
// module chunks = 1